module.exports = __webpack_public_path__ + "e34d7e2c05c13b4a28948a43232cbdb1.png";